import { createContext } from 'react';

interface ScreenSizeContextType {
    baseWidth: number;
    baseHeight: number;
    currentWidth: number;
    currentHeight: number;
    scaleRatioWidth: number;
    scaleRatioHeight: number;
    scaleWidth: (width?: number) => number;
    scaleHeight: (height?: number) => number;
    scaleWidthVw: (width?: number) => string;
    scaleHeightVh: (height?: number) => string;
    scaleWidthPixel: (width?: number) => number;
    scaleHeightPixel: (height?: number) => number;
}

export const ScreenSizeContext = createContext<ScreenSizeContextType | null>(null);
